import React from "react";

import { useModifiersStoreActions } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";
import IconButton from "@replo/design-system/components/button/IconButton";
import { MousePointerClick, X } from "lucide-react";

const EmptyModifierState: React.FC = () => {
  const modifierActions = useModifiersStoreActions();

  return (
    <div className="h-full overflow-auto flex p-3 flex-col gap-3 border-border rounded-xl bg-white border-0.5">
      <div className="flex items-center justify-between flex-shrink-0">
        <div className="flex items-center justify-center gap-2">
          <MousePointerClick className="w-5 h-5" />
          <div className="flex items-center header-h4">Edit</div>
        </div>
        <IconButton
          variant="tertiary"
          size="sm"
          icon={<X className="w-4 h-4" />}
          onClick={() => {
            modifierActions.setDisplayMode("interactive");
          }}
        />
      </div>
      <div className="border-t-0.5 border-border -mx-3 flex-shrink-0" />
      <div className="flex-grow flex flex-col items-center justify-center gap-6 py-16">
        <img
          src="/images/chat/modifiers/empty-modifiers.png"
          alt="No element selected"
          className="w-1/4 object-contain"
        />
        <div className="text-base text-muted text-center">
          Select any element on the preview to make changes
        </div>
      </div>
    </div>
  );
};

export default EmptyModifierState;
